import React, { useEffect, useState } from "react";
import {
  FilterName,
  FilterState,
} from "../../adapters/insights-agent/state/AppState.ts";
import { Button } from "../../ui-library/Button/Button.tsx";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "../../ui-library/Dialog";
import { type FilterOption, FilterOptions } from "./FilterOptions.tsx";
import { LegacyFilterOptions } from "./LegacyFilterOptions.tsx";

export const FilterDialog: React.FC<{
  onClose?(): void;
  onApply?(filters: FilterState): void;
  onClear?(): void;
  legacyFilterOptions?: Partial<Record<FilterName, { value: string[] }>>;
  newFilterOptions?: FilterOption[];
  filterState?: FilterState;
  loading?: boolean;
}> = (props) => {
  const [filterState, setFilterState] = useState<FilterState>(
    props.filterState || {},
  );

  useEffect(() => {
    setFilterState(props.filterState || {});
  }, [props.filterState]);

  const hasNewFormat =
    props.newFilterOptions && props.newFilterOptions.length > 0;
  const hasLegacyFormat =
    props.legacyFilterOptions &&
    Object.keys(props.legacyFilterOptions).length > 0;

  return (
    <Dialog open onClose={props.onClose} size="large">
      <DialogHeader
        title="Filters"
        onClose={props.onClose}
        loading={props.loading}
      />
      <DialogContent padding={false}>
        {hasNewFormat ? (
          <FilterOptions
            filterOptions={props.newFilterOptions!}
            filterState={filterState}
            onFilterChange={setFilterState}
            loading={props.loading}
          />
        ) : hasLegacyFormat ? (
          <LegacyFilterOptions
            filterOptions={props.legacyFilterOptions}
            filterState={filterState}
            onFilterChange={setFilterState}
            loading={props.loading}
          />
        ) : (
          <div style={{ padding: "24px", textAlign: "center" }}>
            No filter options available
          </div>
        )}
      </DialogContent>
      <DialogFooter>
        <Button
          onClick={() => props.onClear?.()}
          disabled={props.loading}
          variant={"transparent"}
        >
          Clear all
        </Button>
        <Button
          onClick={() => props.onApply?.(filterState)}
          disabled={props.loading}
        >
          Apply
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
